import React, { useState } from "react";

import InsuranceBreakDownItem from "./InsuranceBreakDownItem";

// patients -> patients in the files
// allPatients -> all office's patients
export default function InsuranceBreakDownContainer({
  breakdowns,
  setSelectedBreakdown,
  allPatients,
  setSummaryOfSelectedBreakdown,
  getAllOfficePatients,
  selectedBreakdown,
}) {
  const [isSettingPatientId, setIsSettingPatientId] = useState(false); // Loading for the time that insurance patient is changed

  return (
    <div>
      {breakdowns && breakdowns.length > 0 ? (
        breakdowns.map((breakdown) => (
          <InsuranceBreakDownItem
            key={breakdown.id}
            allPatients={allPatients}
            breakdown={breakdown}
            getAllOfficePatients={getAllOfficePatients}
            setSelectedBreakdown={setSelectedBreakdown}
            setSummaryOfSelectedBreakdown={setSummaryOfSelectedBreakdown}
            isSettingPatientId={isSettingPatientId}
            setIsSettingPatientId={setIsSettingPatientId}
            selectedBreakdown={selectedBreakdown}
          />
        ))
      ) : (
        <div style={{ padding: 20, fontSize: 18 }}>No data</div>
      )}
    </div>
  );
}
